import React, { useCallback } from 'react';
import { useIsRedistributionFilterSet } from './useRedistributionFilters';
import PopupFiltersAction from '../../../../../../../components/global/PopupFiltersAction/PopupFiltersAction';
import { useAppDispatch } from '../../../../../../../store';
import { resetFilters } from '../../../../../../Calculations/calculationsSlice';
import CalculationRedistributionFilters from './CalculationRedistributionFilters';

/**
 * Icon button to show the filters for the calculation's redistribution in a popover.
 * <p>When any filter is set, the icon is changes color to reflect that and give the
 * user a feedback that some filters are in effect.</p>
 */
const CalculationRedistributionFiltersAction: React.FC = () => {
  const dispatch = useAppDispatch();
  const isFilterSet = useIsRedistributionFilterSet();

  const resetFiltersHandler = useCallback(() => {
    dispatch(resetFilters());
  }, [dispatch]);

  return (
    <PopupFiltersAction
      title="Filter redistribution by:"
      tooltip="Show additional filters"
      filterSet={isFilterSet}
      resetFilters={resetFiltersHandler}
    >
      <CalculationRedistributionFilters />
    </PopupFiltersAction>
  );
};

export default CalculationRedistributionFiltersAction;
